import React from 'react';
import { Box, spacing } from '@apia/theme';
import CollapsiblePanel from '../../../common/CollapsiblePanel';

const JSONAccordion = ({ obj }: { obj?: unknown }) => {
  const elements = React.useMemo(
    () =>
      obj
        ? Object.entries(obj as Record<string, unknown>).map(([key, value]) => {
            return {
              key,
              value,
              isObject: typeof value === 'object' && value,
            };
          })
        : [],
    [obj],
  );
  return (
    <Box
      sx={{
        p: spacing(4),
        border: '1px solid',
        borderColor: 'palette.border.section',
        bg: 'palette.background.paper',
        ml: spacing(8),
      }}
    >
      {elements.map((element) => {
        const isString = typeof element?.value === 'string';
        const isNumber = typeof element?.value === 'number';
        const isBoolean = typeof element?.value === 'boolean';
        const isUndefined = typeof element?.value === 'undefined';
        const color =
          ['#b00', '#0b0', '#00b', '#555'][
            [isString, isNumber, isBoolean, isUndefined].findIndex((el) => el)
          ] ?? 'black';
        return (
          <React.Fragment key={element.key}>
            {element.isObject && !Array.isArray(element.value) && element && (
              <CollapsiblePanel
                collapsed
                label={element.key}
                id={`${element.key}_JSONAccordion`}
              >
                <pre sx={{ my: 0 }}>
                  <JSONAccordion
                    obj={element.value as Record<string, unknown>}
                  />
                </pre>
              </CollapsiblePanel>
            )}
            {Array.isArray(element.value) &&
              element.value.map((ind, key) => (
                <CollapsiblePanel
                  collapsed
                  id={element.key}
                  label={`${element.key} ${key}`}
                  key={key}
                >
                  <JSONAccordion obj={ind as Record<string, unknown>} />
                </CollapsiblePanel>
              ))}
            {(!element.isObject || !element) && (
              <Box
                sx={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  '*': { wordBreak: 'break-all', whiteSpace: 'normal' },
                  '&:hover': { bg: 'rgba(0, 0, 0, 0.1)' },
                }}
              >
                <Box as="strong">{element?.key}</Box>
                <pre
                  sx={{
                    m: spacing(0),
                    ml: spacing(2),
                    color,
                  }}
                >
                  {isString ? '"' : ''}
                  {String(element?.value)}
                  {isString ? '"' : ''}
                </pre>
              </Box>
            )}
          </React.Fragment>
        );
      })}
    </Box>
  );
};

export default JSONAccordion;
